// extracted by mini-css-extract-plugin
export default {"label":"SelectComponent_label__louDM","content":"SelectComponent_content__Xd7uz"};